/*
 * @Author: 卢靖康
 * @Date: 2019-10-31 17:52:48
 * @LastEditTime: 2021-06-08 16:31:44
 * @LastEditors: 卢靖康
 */
import axios from "../axios";

export default {
  getPageData(inOpts) {
    return axios.request({
      cmd: "homePageIntroduce/list",
      data: inOpts,
    });
  },
  getIndexData(data) {
    return axios.request({
      cmd: "about/nbhx",
      data,
    });
  },
  getHonorsData(data) {
    return axios.request({
      cmd: "about/honors",
      data,
    });
  },
  getClientsData(data) {
    return axios.request({
      cmd: "about/clients",
      data,
    });
  },
  getPartnersData(data) {
    return axios.request({
      cmd: "about/partners",
      data,
    });
  },
  getContactData(data) {
    return axios.request({
      cmd: "about/contact",
      data,
    });
  },
  getGlobalData(data) {
    return axios.request({
      cmd: "about/global",
      data,
    });
  },
};
